import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useRejectPayoutBatch(
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();

  const rejectBatchMutation = useMutation({
    ...trpc.payoutBatches.cancel.mutationOptions(),
    onSuccess,
    onError,
  });

  const rejectBatch = (batchId: string) => {
    if (!merchant?.id) return;

    rejectBatchMutation.mutate(
      { rentalsMerchantId: merchant.id, id: batchId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: trpc.payoutBatches.list.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.ledgerMovements.getBalance.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.payoutBatches.get.queryKey({
              rentalsMerchantId: merchant.id,
              id: batchId,
            }),
          });
        },
      }
    );
  };

  return { rejectBatch, isRejecting: rejectBatchMutation.isPending };
}
